import {
  buyGiftCardPageQuery_products,
  OrderLineInput
} from '../../../core-types';

export function getSum(
  products: buyGiftCardPageQuery_products[],
  orderLines: OrderLineInput[]
): number {
  return orderLines.reduce((accum, orderLine) => {
    if (!products) {
      return accum;
    }
    const product = products.find(p => p.id === orderLine.productId);
    if (product && orderLine.quantity && product.price) {
      accum += product.price * orderLine.quantity;
    }
    return accum;
  }, 0);
}

export function getProduct(
  products: buyGiftCardPageQuery_products[],
  orderLines: OrderLineInput[]
): number | buyGiftCardPageQuery_products | undefined {
  return orderLines.reduce((accum, orderLine) => {
    if (!products) {
      return accum;
    }
    const product = products.find(p => p.id === orderLine.productId);
    return product;
  }, 0);
}
